var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-window',{attrs:{"endpoint":"/reports/accounts_summary","fields":_vm.fields,"title":_vm.title,"headers":_vm.headers,"templates":_vm.templates,"columnsClasses":_vm.columnsClasses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }